import ProdErrorBoundary from './Component';

const DevErrorBoundary = ({ children }) => children;

export const ErrorBoundary = __DEV__ ? DevErrorBoundary : ProdErrorBoundary;
